import * as ai from "@/api/modules/python/ai";

export default {
  ...ai
};
